// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function toString(tabId) {
  switch (tabId) {
    case /* Approve */0 :
        return "approve";
    case /* Reject */1 :
        return "reject";
    case /* Delete */2 :
        return "delete";
    
  }
}

function fromString(tab) {
  switch (tab) {
    case "approve" :
        return /* Approve */0;
    case "delete" :
        return /* Delete */2;
    case "reject" :
        return /* Reject */1;
    default:
      return ErrorUtils$Catalyst.raiseError("AllocationCampaignAction.res", "invalid campaign action", "");
  }
}

export {
  toString ,
  fromString ,
  
}
/* No side effect */
